// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video-module--wrapper--1eKWj","video":"Video-module--video--2kk3Q"};